export default function buildStructuredProduct({ product, router }) {
  if(!product || !router) {
    return {};
  }

  const articleUrl = 'https://www.article.com';


  const structuredProduct = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.title,
    image: product.media && product.media.length ? product.media[0].url : '',
    description: product.description,
    mpn: product.skuNo,
    sku: product.skuNo,
    url: `${articleUrl}${router.resolve({ name: 'product', params: { id: product.hashKey, slug: product.slug } }).href}`,
    productID: product.skuNo,
    itemCondition: 'https://schema.org/NewCondition',
    brand: {
      '@type': 'Brand',
      name: 'Article',
      logo: 'https://images.article.com/logos/article/article_logo_234x30.png',
      url: process.env.STOREFRONT_BASE_URL,
    },
  };

  let priceKey = 'price';
  if (product.onClearance) {
    priceKey = 'clearance';
  } else if (product.onSale) {
    priceKey = 'sale';
  }

  if (product.price && product.price.length) {
    structuredProduct.offers = product.price.map((price) => ({
      '@type': 'Offer',
      price: price[priceKey] ? price[priceKey] / 100 : price['price'] / 100,
      priceCurrency: price.currencyCode,
      url: `${articleUrl}${router.resolve({ name: 'product', params: { id: product.hashKey, slug: product.slug } }).href}`
    }));
  }

  if (product.review && product.review.count && product.review.rating) {
    structuredProduct.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: product.review.rating,
      worstRating: '1',
      bestRating: '5',
      ratingCount: product.review.count,
    };
  }

  if (product.variation && product.variation.length) {
    structuredProduct.isRelatedTo = product.variation.map((variation) => ({
      '@id': `${articleUrl}${router.resolve({ name: 'product', params: { id: variation.hashKey, slug: variation.slug } }).href}#product`,
      '@type': 'Product',
      name: variation.title,
      url: `${articleUrl}${router.resolve({ name: 'product', params: { id: variation.hashKey, slug: variation.slug } }).href}`,
    }));
  }

  if(product.height && product.width && product.depth) {
    structuredProduct.height = `${product.height} in`;
    structuredProduct.width = `${product.width} in`;
    structuredProduct.depth = `${product.depth} in`;
  }

  const category = product?.navigationCategory?.[0];
  if(category) {
    const categoryPath = [category.parentName, category.name].filter(name => name).join('/');
    structuredProduct.category = categoryPath;
  }

  return structuredProduct;
}
